import client from "../../client/client";
import { encodeParam } from "../../utils/utils";

class CoveragePhaseService {
	getAllDocumentsInPhase({ projectId, phaseId }, { filter, page, limit } = {}, cancelToken) {
		return client.get(`/coverage-phases/${phaseId}/projects/${projectId}/documents`, {
			params: { filter: encodeParam(filter), page, limit },
			config: { cancelToken },
		});
	}

	getCompanyModels({ companyId }, cancelToken) {
		return client.get(`/coverage-phases/companies/${companyId}/models`, { config: { cancelToken } });
	}

	getAllByProjectPaginated({ projectId, active }, { page, limit, sort } = {}, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/paginated`, {
			params: { active, page, limit, sort },
			config: { cancelToken },
		});
	}

	getAllByProject({ projectId }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}`, {
			config: { cancelToken },
		});
	}

	existsByName({ projectId, name }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/phases/name-exists`, {
			params: { name },
			config: { cancelToken },
		});
	}

	getCoverage({ projectId }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/coverage`, { config: { cancelToken } });
	}

	deleteCoveragePhase({ projectId, phaseId }, cancelToken) {
		return client.delete(`/coverage-phases/projects/${projectId}/phases/${phaseId}`, { config: { cancelToken } });
	}

	createCoveragePhase({ projectId, phase }, cancelToken) {
		return client.post(`/coverage-phases/projects/${projectId}`, { payload: phase, config: { cancelToken } });
	}

	updateCoveragePhase({ projectId, phaseId, phase }, cancelToken) {
		return client.put(`/coverage-phases/projects/${projectId}/phases/${phaseId}`, {
			payload: phase,
			config: { cancelToken },
		});
	}

	setModelInProject({ projectId }, modelId, cancelToken) {
		return client.put(`/coverage-phases/projects/${projectId}/models`, {
			payload: modelId,
			config: { cancelToken },
		});
	}

	getCoveragePhaseHistory({ projectId, phaseId }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/phases/${phaseId}/history`, {
			config: { cancelToken },
		});
	}

	downloadExportedStrategy({ projectId, exportId }, cancelToken) {
		return client.get(`/export-phase/projects/${projectId}/exports/${exportId}/download`, {
			config: {
				cancelToken,
				responseType: "blob",
			},
		});
	}

	exportStrategy({ projectId, phaseId }, cancelToken) {
		return client.get(`/export-phase/projects/${projectId}/phases/${phaseId}/requirements/xlsx`, {
			config: {
				cancelToken,
				responseType: "blob",
			},
		});
	}

	saveImportStrategyDraft({ projectId, phaseId, importPayload }, cancelToken) {
		return client.post(`/coverage-phases/projects/${projectId}/phases/${phaseId}/import-draft`, {
			payload: importPayload,
			config: { cancelToken },
		});
	}

	getImportStrategyDraft({ projectId, phaseId }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/phases/${phaseId}/import-draft`, {
			config: { cancelToken },
		});
	}

	saveImportStrategyDrafts({ projectId, phaseId, importPayloads }, cancelToken) {
		return client.post(`/coverage-phases/projects/${projectId}/phases/${phaseId}/import-drafts`, {
			payload: importPayloads,
			config: { cancelToken },
		});
	}

	getImportStrategyDrafts({ projectId, phaseId }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/phases/${phaseId}/import-drafts`, {
			config: { cancelToken },
		});
	}

	getImportStrategies({ projectId, phaseId }, cancelToken) {
		return client.get(`/coverage-phases/projects/${projectId}/phases/${phaseId}/imports`, {
			config: { cancelToken },
		});
	}

	validateImportStrategies({ projectId, phaseId, importPayloads }, cancelToken) {
		return client.post(`/coverage-phases/projects/${projectId}/phases/${phaseId}/imports`, {
			payload: importPayloads,
			config: { cancelToken },
		});
	}
}

export default new CoveragePhaseService();
